import React, { useState, useEffect } from "react";
import { CONTACT_MODAL_TEXT } from "./Detailconstants.js";

export default function ContactModal({ isOpen, onClose, query, sectionName }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [isOpen, onClose]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) { setName(""); setEmail(""); setMessage(""); setSubmitted(false); }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) return;
    setSubmitted(true);
  };

  return (
    <div
      className="VF-contact-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      role="dialog"
      aria-modal="true"
      aria-label={`Contact form for ${sectionName}`}
    >
      <div className="VF-contact-modal">
        <button className="VF-contact-modal__close" onClick={onClose} aria-label="Close">✕</button>

        {!submitted ? (
          <>
          
            <h2 className="VF-contact-modal__title">{CONTACT_MODAL_TEXT.title}</h2>
            <p className="VF-contact-modal__subtitle">
              {CONTACT_MODAL_TEXT.subtitle(sectionName)}
            </p>
            {query && (
              <div className="VF-contact-modal__query-preview">
                {CONTACT_MODAL_TEXT.queryPreview(query)}
              </div>
            )}
            <form className="VF-contact-modal__form" onSubmit={handleSubmit} noValidate>
              <div className="VF-form-group">
                <label className="VF-form-label" htmlFor="VF-modal-name">{CONTACT_MODAL_TEXT.form.nameLabel}</label>
                <input id="VF-modal-name" type="text" className="VF-form-input" placeholder={CONTACT_MODAL_TEXT.form.namePlaceholder} value={name} onChange={(e) => setName(e.target.value)} required autoFocus />
              </div>
              <div className="VF-form-group">
                <label className="VF-form-label" htmlFor="VF-modal-email">{CONTACT_MODAL_TEXT.form.emailLabel}</label>
                <input id="VF-modal-email" type="email" className="VF-form-input" placeholder={CONTACT_MODAL_TEXT.form.emailPlaceholder} value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div className="VF-form-group">
                <label className="VF-form-label" htmlFor="VF-modal-message">{CONTACT_MODAL_TEXT.form.messageLabel}</label>
                <textarea id="VF-modal-message" className="VF-form-textarea" placeholder={CONTACT_MODAL_TEXT.form.messagePlaceholder(sectionName)} value={message} onChange={(e) => setMessage(e.target.value)} required />
              </div>
              <button type="submit" className="VF-form-submit" disabled={!name.trim() || !email.trim() || !message.trim()}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                </svg>
                {CONTACT_MODAL_TEXT.form.submit}
              </button>
            </form>
          </>
        ) : (
          <div className="VF-form-success">
            <div className="VF-form-success__icon" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h2 className="VF-form-success__title">{CONTACT_MODAL_TEXT.success.title}</h2>
            <p className="VF-form-success__text">
              {CONTACT_MODAL_TEXT.success.text(name, sectionName, email)}
            </p>
            <button className="VF-btn-secondary VF-btn-secondary--inline" onClick={onClose}>
              {CONTACT_MODAL_TEXT.close}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}